import { watch, onScopeDispose } from "vue";
import TokenAutoExtend from "./TokenAutoExtend";

export function useSessionKeepAlive(dirtyRef) {
  const id = Symbol("session-keep-alive");

  watch(
    dirtyRef,
    (dirty) => {
      if (dirty) {
        TokenAutoExtend.holdKeepAlive(id);
      } else {
        TokenAutoExtend.releaseKeepAlive(id);
      }
    },
    { immediate: true }
  );

  onScopeDispose(() => TokenAutoExtend.releaseKeepAlive(id));
}
